import React from 'react';
import classnames from 'classnames';
import Field from 'shared/components/field/Fields';
import './TextArea.scss';

class TextArea extends Field {
  render() {
    const wrapperClass = classnames({
      'form-group': true,
      'has-error': this.state.error
    });

    const labelClass = classnames({
      'form-label': true
    });

    return (
      <div className={wrapperClass}>
        <label className={labelClass} htmlFor={this.props.name}> {this.props.label} </label>
        <textarea
          name={this.props.name}
          className="form-control"
          value={this.state.value}
          onChange={this.onInputChange}
          onBlur={this.onInputChange}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}

export default TextArea;
